<template>
  <div style="position: relative; z-index: 1">
    <p class="webHeaderImg">
      <img :src="logoUrl" >
      <span>Orange Car</span>
    </p>
    <p class="carInfo">
      现在共有{{sellingCarCount}}辆车供您选购
    </p>
    <div class="carSearch">
      <div class="search_input">
        <el-input placeholder="热门车型搜索"
                  style="height: 75px;margin: -2%"
                  v-model="searchKey"
                  @input="searchByKey"
                  @blur="displayList"
                  >
        </el-input>
        <div class="result_class" v-if="searchList.length !== 0">
          <ul>
            <li v-for="(car,index) in searchList" @click="showCar(car)">{{car.fullname}}</li>
          </ul>
        </div>
<!--        <el-button type="primary" icon="el-icon-search"></el-button>-->
        <div v-if="hotCar.length !== 0" class="font_class">
          <span class="hot_class">当前热门：</span>
          <span v-for="(car,index) in hotCar" class="hotCar_class hot_class" @click="showCar(car)">{{car.fullname}}</span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "WebHeader",
  data(){
    return{
      logoUrl: require("../assets/logo.png"),
      searchKey: '', //热门车型搜索
      sellingCarCount: '', //在售车辆
      // avatarUrl: ''
      hotCar:[],
      searchList:[],
      timer: null
    }
  },
  methods:{
    searchByKey(){
      var token = localStorage.getItem('token')
      if(!token){
        this.$message.info("请先登录")
      }else{
        let obj = {
          key: this.searchKey
        }
        var fd = new FormData()
        fd.append('info',JSON.stringify(obj))
        this.axios.post('/car/searchByKey',fd).then(res => {
          if(res.data.code === 0){
            this.searchList = res.data.data.carList
          }
        })
        // console.log(this.searchKey)
      }

    },
    displayList(){
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // 在此处编写要触发的事件
        this.searchList = []
        this.searchKey = ''
      }, 500)
    },
    //查看车辆详情
    showCar(car){
      this.searchKey = car.fullname
      this.$router.push({path:'/index/carInfo',query:{carId:car.id}});
    },
    //热门车型获取
    getHotCarInfo(){
      this.axios.get('/car/getHotCarInfo').then(res => {
        if(res.data.code === 0){
          this.hotCar = res.data.data.carList
        }
      })
    }
  },
  created() {
    this.axios.get('/car/getSellingCarCount').then(res =>{
      if(res.data.code === 0){
        this.sellingCarCount = res.data.data.count
      }
    })
    this.getHotCarInfo()
  }


}
</script>

<style scoped>
.webHeaderImg {
  float: left;
  /*margin-left: 13%;*/
  margin-top: 0;
  display: inline-block;
}
.webHeaderImg >>> img {
  width: 115px;
}
.webHeaderImg >>> span {
  margin-left: -48%;
  font-weight: bold;
  font-family: 黑体;
  font-size: large;
  color: orange;
}
.search_input{
  display: inline-block;
  width: 70%;
  float: right;
  /*padding-top: 10px;*/
}

.carInfo {
  float: left;
  display: inline-block;
  margin-left: 12%;
  margin-top: 1%;
}

.carSearch {
  /*float: left;*/
  display: inline-block;
  height: 100px;
  width: 32%;
  position: absolute;
  z-index: 1;
  /*margin-left: 10%;*/
}

.el-input {
  float: left;
  width: 55% ;
  margin-left: 5%;
}
/*.carSearch >>> el-button-primary {*/
/*  border-color: white;*/
/*  color: orangered;*/
/*}*/

.carSearch >>> button {
  /*display: inline-block;*/
  background-color: orangered;
  /*float: left;*/
  /*margin-top: 7%;*/
}

/*.carSearch >>> input {*/
/*  width: 50%;*/
/*  float: left;*/
/*  margin-top: 10%;*/
/*  height: 28px;*/
/*  display: inline-block;*/
/*}*/
/*.carSearch >>> button {*/
/*  width: 16%;*/
/*  height: 32px;*/
/*  margin-top: 10%;*/
/*  float: left;*/
/*  display: inline-block;*/
/*}*/

/*.carSearch >>> span {*/
/*  float: right;*/
/*  margin-top: -16%;*/
/*  margin-right: 59%;*/
/*  font-size: small;*/
/*  font-family: 幼圆;*/
/*}*/

/*.userSHow{*/
/*  display: inline-block;*/
/*  width: 30px;*/
/*  height: 30px;*/
/*}*/
.font_class{
  display: inline;
  height: 40px;
  float: left;
  padding-top: 15%;
  margin-left: -50%;
}
.hot_class{
  font-size: small;
  display: inline-block;
  float: left;
  line-height: 30px;
}
.hotCar_class{
  color: rgba(237,49,32,0.75);
  cursor: pointer;
  padding-right: 10px;
}
.result_class{
  width: 40%;
  height: 200px;
  overflow-y: scroll;
  position: absolute;
  background-color: rgba(196,190,174,0.75);
  border-radius: 10px;
  z-index: 2;
  margin-top: 12%;
}
.result_class >>> ul,li{
  list-style: none;
  line-height: 30px;
  padding: 0;
  margin: 0;
  z-index: 2;
  cursor: pointer;
}
.result_class >>> li:hover{
  background-color: rgba(102,96,84,0.8);
}
</style>